import TimelinePositions from "../types/TimelinePositions";

export default function getTimelinePositionsDuration(
  timelinePositions: TimelinePositions,
) {
  return Array.from(timelinePositions.values()).reduce(
    (totalDuration, { endTime, startTime }) =>
      totalDuration + endTime - startTime,
    0,
  );
}
